import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { Alert, Row, Col, Form, FormControl } from 'react-bootstrap';
import Snackbar from '@material-ui/core/Snackbar';
import { Button } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import Header from '../header/Header';
import {
  Container,
  HomeButtons,
  Wrapper,
  SmallButton
} from '../../styles/HomeStyles';
import { FormWrapper, Label } from '../../styles/LoginStyles';
import { config } from '../../config';
import { Toast } from '../student/Home';

export default function ResetPassword() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [usernameError, setUsernameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [status, setStatus] = useState('');
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertFailure, setAlertFailure] = useState(false);

  const onSendClick = () => {
    const userData = {
      email
    };

    axios
      .post(`${config.API_URL}user/auth/user/reset-password`, userData)
      .then(response => {
        setEmail('');
        setStatus('Reset Link has been sent to the email provided');
        setAlertSuccess(true);
        // this.setState({ status: "success" });
      })
      .catch(error => {
        setEmail('');
        setStatus('Something went wrong!');
        setAlertFailure(true);
        // if (error.response && error.response.data.hasOwnProperty('email')) {
        //   setEmailError(error.response.data.username);
        //   // this.setState({ emailError: error.response.data["email"] });
        // } else {
        //   setStatus('error');
        //   // this.setState({ status: "error" });
        // }
      });
  };

  const errorAlert = (
    <Alert variant="danger">
      <Alert.Heading>Problem during reset password email send</Alert.Heading>
      Please try again or contact service support for further help.
    </Alert>
  );

  const successAlert = (
    <Alert variant="success">
      <Alert.Heading>Email sent </Alert.Heading>
      <p>
        We send you an email with reset password link. Please check your email.
      </p>
      <p>
        Please try again or contact us if you do not receive it within a few
        minutes.
      </p>
    </Alert>
  );

  const form = (
    <div>
      <FormWrapper>
        <Form>
          <Form.Group controlId="emailId">
            <Label>Email</Label>
            <Form.Control
              isInvalid={emailError}
              type="text"
              name="email"
              placeholder="Enter email"
              value={email}
              onChange={e => setEmail(e.currentTarget.value)}
            />
            <FormControl.Feedback type="invalid">
              {emailError}
            </FormControl.Feedback>
          </Form.Group>
        </Form>
        <center>
          <Button
            variant="contained"
            color="primary"
            disabled={email === ''}
            onClick={onSendClick}
          >
            Send Reset Link
          </Button>
        </center>
      </FormWrapper>
    </div>
  );

  let alert = '';
  if (status === 'error') {
    alert = errorAlert;
  } else if (status === 'success') {
    alert = successAlert;
  }

  const handleClose = (event, reasons) => {
    if (reasons === 'clickaway') {
      return;
    }
    setAlertFailure(false);
    setAlertSuccess(false);
  };

  return (
    <Container>
      <Header isHome={true} center={true} />
      <Wrapper>
        <Snackbar
          open={alertFailure}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Toast onClose={handleClose} severity="error">
            {status}
          </Toast>
        </Snackbar>
        <Snackbar
          open={alertSuccess}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Toast onClose={handleClose} severity="success">
            {status}
          </Toast>
        </Snackbar>
        {/* {alert} */}
        {status !== 'success' && form}
      </Wrapper>
    </Container>
  );
}
